"use client"
import { ComponentConfig } from "@measured/puck"
import { BaseSystemProps, RenderConfig } from "./RenderConfig"

// Interface định nghĩa cho dữ liệu baseSystem từ API

export const GGMap: ComponentConfig<BaseSystemProps> = {
  label: "GG Map",
  // @ts-ignore
  fields: {
    title: {
      type: "text",
      label: "Title",
    },
  },
  defaultProps: {
    title: "Title",
    className: "",
  },
  ...RenderConfig,
}
